/**
 * mypanthos-filters.js
 * Trasformazioni visive filtri Horizon — swatch colori + pill forma SVG
 *
 * Osserva document.body (subtree) per sopravvivere ai re-render AJAX di
 * Horizon, che sostituiscono i nodi dei filtri. I marker data-mp* rendono
 * il processing idempotente, evitando loop e doppio lavoro.
 */

(function () {
  'use strict';

  /* ------------------------------------------------------------------
     MAPPA COLORI
  ------------------------------------------------------------------ */
  const COLOR_MAP = {
    'nero': '#1c1c1c',
    'nero lucido': '#1c1c1c',
    'nero opaco': '#2d2d2d',
    'bianco': '#f5f5f0',
    'grigio': '#9e9e9e',
    'marrone': '#6d4c41',
    'miele': '#c68b2a',
    'oro': '#c9a84c',
    'argento': '#b0bec5',
    'blu': '#1565c0',
    'rosso': '#c62828',
    'rosa': '#e91e8c',
    'verde': '#2e7d32',
    'giallo': '#f9a825',
    'arancione': '#e65100',
    'viola': '#6a1b9a',
    'turchese': '#00838f',
    'borgogna': '#6d1a36',
    'beige': '#d7c4a8',
    'mattone': '#b5451b',
    'tartarugato': '#8b6914',
    'tartarugata': '#8b6914',
    'tortoise': '#8b6914',
    'legno': '#a0522d',
    'fumo': '#607d8b',
    'trasparente': 'transparent',
    'transparente': 'transparent',
    'fluo': '#b8ff00',
    'opaco': '#888888',
    'lucido': '#d4d4d4',
  };

  const LIGHT_COLORS = new Set([
    '#f5f5f0', '#d7c4a8', '#c9a84c', '#b0bec5',
    '#f9a825', '#b8ff00', '#d4d4d4'
  ]);

  /* ------------------------------------------------------------------
     SVG FORME — viewBox 0 0 24 16, lente singola centrata.
     Nomi metafield reali: Aviatore, Esagonale, Gatto, Maschera,
     Ovale, Quadrata, Rettangolare, Rotonda.
  ------------------------------------------------------------------ */
  /* Icone forma: PNG caricati come File su Shopify.
     Usate come CSS mask (background-color: currentColor) cosi' l'icona
     eredita il colore del testo della pill: grigia da spenta, bianca
     quando la pill e' attiva (sfondo nero). Per cambiare gli URL basta
     intervenire qui. */
  const ICON_BASE = 'https://cdn.shopify.com/s/files/1/0929/8264/1024/files/';
  const SHAPE_ICONS = {
    'aviatore':     'icona-aviatore.svg',
    'esagonale':    'icona-esagonale.svg',
    'gatto':        'icona-gatto.svg',
    'maschera':     'icona-maschera.svg',
    'ovale':        'icona-ovale.svg',
    'quadrata':     'icona-quadrata.svg',
    'rettangolare': 'icona-rettangolare.svg',
    'rotonda':      'icona-rotonda.svg',
    'farfalla':     'icona-farfalla.svg',
    'fuori_misura': 'icona-fuori_misura.svg'
  };

  /* ------------------------------------------------------------------
     resolveColor: "Nero, Oro" -> { type, colors[] }
  ------------------------------------------------------------------ */
  function resolveColor(labelText) {
    const parts = labelText.trim().split(/,\s*/).map(p => p.trim().toLowerCase());
    const resolved = [];
    const sortedKeys = Object.keys(COLOR_MAP).sort((a, b) => b.length - a.length);

    for (const part of parts) {
      if (COLOR_MAP[part] !== undefined) { resolved.push(COLOR_MAP[part]); continue; }
      for (const key of sortedKeys) {
        if (part.includes(key)) { resolved.push(COLOR_MAP[key]); break; }
      }
    }

    if (resolved.length === 0) return null;
    const nonTransparent = resolved.filter(h => h !== 'transparent');
    if (nonTransparent.length === 0) return { type: 'transparent', colors: [] };
    if (nonTransparent.length === 1) return { type: 'single', colors: [nonTransparent[0]] };
    const c1 = nonTransparent[0];
    const c2 = nonTransparent.find(h => h !== c1) || null;
    if (!c2) return { type: 'single', colors: [c1] };
    return { type: 'double', colors: [c1, c2] };
  }

  function buildSwatch(colorResult, labelText) {
    const wrapper = document.createElement('span');
    wrapper.className = 'mp-swatch-wrapper';

    const swatch = document.createElement('span');
    swatch.className = 'mp-swatch';
    swatch.setAttribute('aria-hidden', 'true');

    if (!colorResult || colorResult.type === 'transparent') {
      swatch.classList.add('mp-swatch--transparent');
    } else if (colorResult.type === 'single') {
      const hex = colorResult.colors[0];
      swatch.style.background = hex;
      if (LIGHT_COLORS.has(hex)) swatch.classList.add('mp-swatch--light');
    } else {
      const h1 = document.createElement('span');
      h1.className = 'mp-swatch-half';
      h1.style.background = colorResult.colors[0];
      const h2 = document.createElement('span');
      h2.className = 'mp-swatch-half';
      h2.style.background = colorResult.colors[1];
      swatch.appendChild(h1);
      swatch.appendChild(h2);
    }

    const tooltip = document.createElement('span');
    tooltip.className = 'mp-swatch-tooltip';
    tooltip.textContent = labelText;

    wrapper.appendChild(swatch);
    wrapper.appendChild(tooltip);
    return wrapper;
  }

  /* ------------------------------------------------------------------
     Trasforma filtri colore: inietta swatch prima di .icon-checkmark
  ------------------------------------------------------------------ */
  function transformColorFilter(accordion) {
    accordion.querySelectorAll('.checkbox').forEach(checkbox => {
      const label = checkbox.querySelector('.checkbox__label');
      if (!label) return;

      // Guard basato sulla PRESENZA REALE: Horizon aggiorna i nodi in-place
      // (morphing) rimuovendo la nostra iniezione ma preservando il nodo.
      // Un marker-attributo sopravviverebbe e bloccherebbe la re-iniezione.
      if (label.querySelector('.mp-swatch-wrapper')) return;

      const labelTextEl = checkbox.querySelector('.checkbox__label-text');
      const iconCheckmark = label.querySelector('.icon-checkmark');
      if (!labelTextEl || !iconCheckmark) return;

      const text = labelTextEl.textContent.trim();
      label.insertBefore(buildSwatch(resolveColor(text), text), iconCheckmark);
    });
  }

  /* ------------------------------------------------------------------
     Trasforma filtro forma: nasconde .checkbox, inserisce pill fratello
  ------------------------------------------------------------------ */
  function transformFormaFilter(accordion) {
    accordion.querySelectorAll('.facets__inputs-list-item').forEach(li => {
      const checkboxDiv = li.querySelector('.checkbox');
      if (!checkboxDiv) return;

      // Guard basato sulla PRESENZA REALE della pill.
      // Se la pill esiste già, assicura solo che il checkbox resti nascosto
      // (il morph di Horizon può aver rimosso la classe) ed esce.
      if (li.querySelector('.mp-forma-pill-wrapper')) {
        checkboxDiv.classList.add('mp-hidden');
        return;
      }

      const input = checkboxDiv.querySelector('.checkbox__input');
      const labelTextEl = checkboxDiv.querySelector('.checkbox__label-text');
      if (!input || !labelTextEl) return;

      const formaName = labelTextEl.textContent.trim();
      const iconFile = SHAPE_ICONS[formaName.toLowerCase()] || '';

      const pillWrapper = document.createElement('span');
      pillWrapper.className = 'mp-forma-pill-wrapper';

      const pill = document.createElement('span');
      pill.className = 'mp-forma-pill';
      pill.setAttribute('role', 'presentation');

      // Icona come CSS mask: eredita currentColor (vedi CSS .mp-forma-icon)
      if (iconFile) {
        const icon = document.createElement('span');
        icon.className = 'mp-forma-icon';
        icon.setAttribute('aria-hidden', 'true');
        const maskUrl = "url('" + ICON_BASE + iconFile + "')";
        icon.style.webkitMaskImage = maskUrl;
        icon.style.maskImage = maskUrl;
        pill.appendChild(icon);
      }

      const labelSpan = document.createElement('span');
      labelSpan.textContent = formaName;
      pill.appendChild(labelSpan);

      pillWrapper.appendChild(pill);

      pill.addEventListener('click', function () {
        input.checked = !input.checked;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      checkboxDiv.classList.add('mp-hidden');
      checkboxDiv.insertAdjacentElement('afterend', pillWrapper);
    });
  }

  function processAccordion(accordion) {
    const param = accordion.getAttribute('data-filter-param-name') || '';
    if (param.includes('colore_montatura') || param.includes('colore_lenti')) {
      transformColorFilter(accordion);
    }
    if (param.includes('scheda_tecnica-forma')) {
      transformFormaFilter(accordion);
    }
  }

  /* ------------------------------------------------------------------
     Processa tutti gli accordion presenti nel documento (desktop + mobile).
     Ri-query fresca a ogni chiamata: sopravvive a qualsiasi sostituzione
     di nodi fatta da Horizon.
  ------------------------------------------------------------------ */
  function processAll() {
    document.querySelectorAll('accordion-custom[data-filter-param-name]')
      .forEach(processAccordion);
  }

  function debounce(fn, ms) {
    let t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, ms);
    };
  }

  /* ------------------------------------------------------------------
     BARRA INFERIORE MOBILE — "Filtri" + "Ordina"
     Riusa il bottone toggle nativo di Horizon (.facets-toggle__button)
     che porta il binding #filters-drawer/showDialog: lo clicchiamo
     programmaticamente, quindi il drawer si apre col meccanismo nativo.
     "Ordina" apre lo stesso pannello e scrolla alla sezione ordinamento
     (che Horizon colloca in fondo al drawer).
  ------------------------------------------------------------------ */
  const ICON_FILTRI = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 5h18M6 12h12M10 19h4"/></svg>';
  const ICON_ORDINA = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M7 4v16M7 20l-3-3M7 20l3-3M17 20V4M17 4l-3 3M17 4l3 3"/></svg>';

  function openDrawer() {
    const toggle = document.querySelector('.facets-toggle__button');
    if (toggle) toggle.click();
  }

  function updateMobileBarCount() {
    const bar = document.querySelector('.mp-mobile-bar');
    if (!bar) return;
    const badge = bar.querySelector('.mp-mobile-bar__count');
    if (!badge) return;
    // Legge il conteggio filtri attivi dal bubble nativo di Horizon
    const native = document.querySelector('#filter-count-bubble-toggle .filter-count-bubble__text');
    const n = native ? parseInt(native.textContent.trim(), 10) : 0;
    if (n > 0) {
      badge.textContent = n;
      badge.style.display = '';
    } else {
      badge.style.display = 'none';
    }
  }

  function buildMobileBar() {
    if (document.querySelector('.mp-mobile-bar')) {
      updateMobileBarCount();
      return;
    }
    // Senza il toggle nativo non ci sono filtri: niente barra
    if (!document.querySelector('.facets-toggle__button')) return;

    const bar = document.createElement('div');
    bar.className = 'mp-mobile-bar';
    bar.innerHTML =
      '<button type="button" class="mp-mobile-bar__btn" data-mp-action="filtri">' +
        ICON_FILTRI + '<span>Filtri</span>' +
        '<span class="mp-mobile-bar__count" style="display:none"></span>' +
      '</button>' +
      '<button type="button" class="mp-mobile-bar__btn" data-mp-action="ordina">' +
        ICON_ORDINA + '<span>Ordina</span>' +
      '</button>';

    document.body.appendChild(bar);

    bar.querySelector('[data-mp-action="filtri"]').addEventListener('click', openDrawer);

    bar.querySelector('[data-mp-action="ordina"]').addEventListener('click', function () {
      openDrawer();
      setTimeout(function () {
        const sorting = document.querySelector(
          '#filters-drawer sorting-filter-component, #filters-drawer .sorting-filter'
        );
        if (sorting) sorting.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 360);
    });

    updateMobileBarCount();
  }

  /* ------------------------------------------------------------------
     Init — observer globale su body.
     Horizon re-renderizza sostituendo i nodi dei filtri; osservando il
     body intercettiamo ogni re-render ovunque avvenga. Idempotente grazie
     ai marker data-mp*: il secondo passaggio non inserisce nulla.
  ------------------------------------------------------------------ */
  function init() {
    if (!document.querySelector('accordion-custom[data-filter-param-name]')) {
      // I filtri potrebbero non esserci ancora (drawer lazy): attendi comunque
    }

    processAll();
    buildMobileBar();

    const reprocess = debounce(function () {
      processAll();
      buildMobileBar();
    }, 80);
    const observer = new MutationObserver(mutations => {
      // Ignora mutation causate solo dalle nostre stesse iniezioni
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node.nodeType === 1 &&
              !node.classList.contains('mp-forma-pill-wrapper') &&
              !node.classList.contains('mp-swatch-wrapper')) {
            reprocess();
            return;
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
